"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
 mutation resetStripeConnection($orgId:String) {
  resetStripeConnection(orgId: $orgId) 
}
`;
exports.default = mutation;
//# sourceMappingURL=resetStripeConnection.mutation.js.map